<template>
  <div class="reservation">

    <Transition>
      <div class="trg" @click="trg = true" v-if="!trg">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M120-241.54v-40h382.31v40H120Zm0-191.54v-40h178.46v40H120Zm0-191.54v-40h178.46v40H120ZM811.69-240 656.15-393.23q-21.69 16.23-47.11 25.11-25.42 8.89-52.12 8.89-67.35 0-114.83-46.58-47.47-46.57-47.47-113.81 0-67.23 47.52-113.8Q489.67-680 557.11-680q67.43 0 114.77 46.58 47.35 46.57 47.35 113.42 0 26.69-8.88 52.12-8.89 25.42-25.89 46.34L840-268.31 811.69-240ZM556.92-399.23q50.96 0 86.64-35 35.67-35 35.67-85.39 0-50.38-35.67-85.38-35.68-35-86.64-35t-86.63 35q-35.67 35-35.67 85.38 0 50.39 35.67 85.39t86.63 35Z"/></svg>
      </div>
    </Transition>

    <Transition>
      <div class="form" v-if="trg">
        <i class="close" @click="trg = false"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/></svg></i>
        <h2>空室・宿泊プラン検索</h2>
        <form action="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do" method="get" target="_blank">
          <input type="hidden" name="yadNo" value="339445">
          
          <dl>
            <dt>宿泊日</dt>
            <dd>
              <label>
                <select name="stayYear" v-model="stayYear">
                  <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                </select>
                <span>年</span>
              </label>
      
              <label>
                <select name="stayMonth" v-model="stayMonth">
                  <option v-for="month in months" :key="month" :value="month">{{ month }}</option>
                </select>
                <span>月</span>
              </label>
      
              <label>
                <select name="stayDay" v-model="stayDay">
                  <option v-for="day in days" :key="day" :value="day">{{ day }}</option>
                </select>
                <span>日</span>
              </label>
            </dd>
          </dl>
  
          <dl>
            <dt>人数・部屋数</dt>
            <dd>
              <label>
                <select name="adultNum" v-model="adultNum">
                  <option v-for="num in adults" :key="num" :value="num">{{ num }}</option>
                </select>
                <span>人</span>
              </label>
  
              <label>
                <select name="stayCount" v-model="stayCount">
                  <option v-for="n in stays" :key="n" :value="n">{{ n }}</option>
                </select>
                <span>泊</span>
              </label>
  
              <label>
                <select name="roomCount" v-model="roomCount">
                  <option v-for="n in rooms" :key="n" :value="n">{{ n }}</option>
                </select>
                <span>部屋</span>
              </label>
            </dd>
          </dl>
          <div class="send">
            <a href="https://www.jhpds.net/wakamatsuhonten/uw/uwp3100/uww3101.do?yadNo=339445" target="_blank" rel="nofollw">全てのプランを見る<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="M212.31-140Q182-140 161-161q-21-21-21-51.31v-535.38Q140-778 161-799q21-21 51.31-21h252.3v60h-252.3q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v535.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h535.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46v-252.3h60v252.3Q820-182 799-161q-21 21-51.31 21H212.31Zm176.46-206.62-42.15-42.15L717.85-760H560v-60h260v260h-60v-157.85L388.77-346.62Z"/></svg></a>
            <input type="submit" value="検索する">
          </div>
        </form>
      </div>
    </Transition>

    <Transition name="fade">
      <div class="overlay" v-if="trg"></div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
.reservation{
  position: fixed;
  right: 1.6rem;
  bottom: 1.6rem;
  z-index: 999;
  @media screen and (max-width: module.$phone){
    right: 1rem;
    bottom: 1rem;
  }
  .trg{
    width: 5.2rem;
    height: 5.2rem;
    border-radius: 50%;
    @include module.flex();
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    right: 0;
    box-shadow: 1rem 1rem 3.2rem rgba(module.$normal,.24);
    z-index: 100;
    @media screen and (max-width: module.$phone){
      width: 4.8rem;
      height: 4.8rem;
    }
    &:before{
      content: '';
      width: 100%;
      height: 100%;
      background: module.$white;
      border-radius: 50%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      transition: all 400ms module.$ease;
    }
    &:hover{
      &:before{
        transform: scale(1.1);
        background: module.$base;
      }
      svg{
        fill: module.$white;
      }
    }
    svg{
      width: 2.4rem;
      display: block;
      margin: 0 auto;
      fill: module.$base;
      transition: fill 400ms module.$ease;
    }
  }

  .form{
    background: module.$white;
    border-radius: 1rem;
    box-shadow: 1rem 1rem 4rem rgba(module.$normal,.16), -.6rem -.6rem 2.4rem rgba(module.$normal,.12);
    position: relative;
    .close{
      background: module.$base;
      width: 3.6rem;
      height: 3.6rem;
      border-radius: 50%;
      position: absolute;
      right: -.8rem;
      top: -.8rem;
      z-index: 10;
      @include module.flex();
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 400ms module.$ease;
      &:hover{
        background: module.$normal;
        transform: scale(1.1);
      }
      svg{
        width: 1.4rem;
        fill: module.$gray;
      }
    }
    h2{
      padding: 1.2rem 1.6rem;
      font-size: 1.12rem;
      font-weight: 700;
      background: module.$gray;
      border-radius: 1rem 1rem 0 0;
    }
    > form{
      padding: 1.6rem;
      dl{
        display: grid;
        grid-template-columns: 7.2rem 1fr;
        gap: 1.2rem;
        margin: 0 0 1.2rem;
        padding: 0 0 1.2rem;
        border-bottom: module.$border 1px solid;
        @media screen and (max-width: module.$phone){
          grid-template-columns: 1fr;
        }
        > * {
          align-self: center;
        }
        dd{
          @include module.flex();
          justify-content: flex-start;
          align-items: center;
          label{
            margin: 0 1rem 0 0;
            &:last-of-type{
              margin: 0;
            }
            select{
              @include module.font();
              font-size: .92rem;
              line-height: 1.5;
              padding: .24rem .8rem;
              min-width: 5.6rem;
              display: inline-block;
              border: module.$border 2px solid;
              background: module.$border;
              border-radius: .4rem;
              margin: 0 .4rem 0 0;
              @media screen and (max-width: module.$phone){
                min-width: 3.2rem;
              }
            }
          }
        }
      }
    }
    .send{
      @include module.flex();
      align-items: flex-end;
      justify-content: flex-end;
      a{
        color: module.$base;
        font-weight: 700;
        text-decoration: underline;
        display: inline-flex;
        align-items: center;
        svg{
          width: 1.2rem;
          fill: module.$base;
        }
      }
      input{
        @include module.font();
        color: module.$white;
        font-size: 1.08rem;
        line-height: 1.5;
        padding: .48rem 1.6rem;
        background: module.$base;
        border: module.$base 1px solid;
        border-radius: .4rem;
        margin: 0 0 0 2rem;
        cursor: pointer;
        &:hover{
          background: module.$white;
          color: module.$base;
        }
      }
    }
  }
  .overlay{
    width: 100%;
    height: 100%;
    background: rgba(#000,.32);
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    backdrop-filter: saturate(90%) blur(20px);
  }
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s module.$ease;
    transition-property: opacity,transform;
    transform-origin: right bottom;
  }
  .v-enter-from,
  .v-leave-to {
    transform: scale(.8);
    opacity: 0;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s module.$ease;
    transition-property: opacity;
    transform-origin: right bottom;
  }
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>

<script>
import { ref } from 'vue'

export default {
  setup() {
    const trg = ref(false)

    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1
    const currentDay = today.getDate()

    const years = [currentYear, currentYear + 1, currentYear + 2]
    const months = Array.from({ length: 12 }, (_, i) => i + 1)
    const days = Array.from({ length: 31 }, (_, i) => i + 1)
    const adults = Array.from({ length: 12 }, (_, i) => i + 1)
    const stays = Array.from({ length: 5 }, (_, i) => i + 1)
    const rooms = Array.from({ length: 12 }, (_, i) => i + 1)

    const stayYear = ref(currentYear)
    const stayMonth = ref(currentMonth)
    const stayDay = ref(currentDay)
    const adultNum = ref(2)
    const stayCount = ref(1)
    const roomCount = ref(1)

    return {
      trg,
      years,
      months,
      days,
      adults,
      stays,
      rooms,
      stayYear,
      stayMonth,
      stayDay,
      adultNum,
      stayCount,
      roomCount
    }
  },
}
</script>